export const setSearchParam = (search, param, value) => {
  const searchParam = new URLSearchParams(search);
  searchParam.set(param, value);
  return searchParam.toString();
};
